import React from 'react';
import { useFormikContext } from 'formik';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import './FormikTextInputField.scss';

type Props = {
    'data-testid'?: string;
    inputFieldId: string;
    label: string;
    className?: string;
    isOptional?: boolean;
    placeholder?: string;
};

export const FormikTextInputField = ({
    className,
    inputFieldId,
    isOptional,
    label,
    placeholder,
    ...extra
}: Props): JSX.Element => {
    const { t } = useTranslation('common');
    const {
        errors = {},
        touched = {},
        values = {},
        isSubmitting,
        setFieldTouched,
        setFieldValue
    } = useFormikContext<Record<string, string>>();
    const isWithError = Boolean(errors[inputFieldId]);
    const isTouched = Boolean(touched[inputFieldId]);
    const isErrorState = isTouched && isWithError;
    const value = values[inputFieldId];

    return (
        <label
            htmlFor={inputFieldId}
            className="formiktextinputfield _w-100 _d-grid"
            data-testid={extra['data-testid'] || 'label-textinputfield'}
        >
            <div className="_fd-row" data-testid="label-textinputfield-title">
                {label && (
                    <>
                        <span className="formiktextinputfield-title">
                            {label}
                        </span>
                        {isOptional && (
                            <span className="_text-2">{t('optional')}</span>
                        )}
                    </>
                )}
            </div>

            <input
                type="text"
                id={inputFieldId}
                disabled={isSubmitting}
                data-testid="textInputField"
                className={classnames('label-input', {
                    'label-input--error': isErrorState
                })}
                placeholder={placeholder}
                value={value}
                onChange={(e) => {
                    setFieldValue?.(inputFieldId, e.target.value);
                }}
                onBlur={() => {
                    setFieldTouched?.(inputFieldId);
                }}
            />
        </label>
    );
};
